export type PasswordStrength = "weak" | "medium" | "strong";

export const getPasswordStrength = (
  password?: string
): PasswordStrength | undefined => {
  if (!password) {
    return undefined;
  }

  const score = [
    password.length >= 8,
    password.length >= 12,
    /[a-z]/.test(password),
    /[A-Z]/.test(password),
    /\d/.test(password),
    /[^A-Za-z0-9]/.test(password),
  ].filter(Boolean).length;

  if (score <= 3) {
    return "weak";
  }

  if (score <= 5) {
    return "medium";
  }

  return "strong";
};
